export const ENTER_KEY_CODE = 13;
export const TAB_KEY_CODE = 9;
export const SPACE_KEY_CODE = 32;
export const ARROWLEFT_KEY_CODE = 37;
export const ARROWRIGHT_KEY_CODE = 39;

export const ARROWDOWN_KEY = 'ArrowDown';
export const ARROWUP_KEY = 'ArrowUp';
